import React from "react";
import {Form} from "antd";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";


// eslint-disable-next-line no-unused-vars
const OPTIONS = [
  {frq: '421.996875', label: "디지털 1"},
  {frq: '422.003125', label: '디지털 2'},
  {frq: '422.009375', label: '디지털 3'},
  {frq: '422.015625', label: '디지털 4'},
  {frq: '422.021875', label: '디지털 5'},
  {frq: '422.028125', label: '디지털 6'},
  {frq: '422.034375', label: '디지털 7'},
  {frq: '422.040625', label: '디지털 8'},
  {frq: '422.046875', label: '디지털 9'},
  {frq: '422.053125', label: '디지털 10'},
  {frq: '422.000000', label: '아날로그 1'},
  {frq: '422.012500', label: '아날로그 2'},
  {frq: '422.025000', label: '아날로그 3'},
  {frq: '422.037500', label: '아날로그 4'},
  {frq: '422.050000', label: '아날로그 5'},
];


function WidgetFrq({ options, iconCodeByFrq }) {
  return (
    <Form.Item>
      <CheckboxGroupWithCheckAll
        title="주파수"
        fieldName={"frq_list"}
        options={options.map(({ frq_code, label }) => ({
          value: frq_code,
          label,
          iconCode: iconCodeByFrq[frq_code],
        }))}
        colSpan={12} />
    </Form.Item>
  );
}


export default WidgetFrq;
